"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countryMap = {
    CA: 'Canada',
    US: 'United States',
};
exports.default = countryMap;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3VudHJ5L2NvdW50cnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFNQSxNQUFNLFVBQVUsR0FBZTtJQUM3QixFQUFFLEVBQUUsUUFBUTtJQUNaLEVBQUUsRUFBRSxlQUFlO0NBQ3BCLENBQUM7QUFFRixrQkFBZSxVQUFVLENBQUMifQ==